import axios from '../../../axiosConfig';

export async function getChangeLogs(config = {}) {
    return await axios.get(`/v1/audit`, config);
}

const functions = { getChangeLogs}
export default functions
